<p-dialog [header]="title_modal" [(visible)]="showDialog" (onShow)="scrollToTop()"
  [style]="{'max-height':'90vh', 'width': '90vw'}" (onHide)="deleteInterval()">

  <div class="d-flex flex-wrap justify-content-between w-100">
    <div [style]="{'width': navigationService.isMobile() ? '100%' : '20%', 'position': 'relative'}">
      <div class="sticky-top px-2">
        <h3>Información</h3>
        <ul style="list-style: none;">
          <li><b>Fecha:</b> {{data?.aux_fecha}}</li>
          <li><b>Maquinaria:</b> {{data?.maquinaria_nombre}}</li>
        </ul>
        <h3>Datos Media:</h3>
        <ul style="list-style: none;">
          <li><b>Caudal:</b> {{quantityFlow}}</li>
          <li><b>Presión:</b> {{quantityPressure}}</li>
          <li><b>Velocidad:</b> {{quantityVelocidad}}</li>
          <li><b>Dosis:</b> {{quantityDosis}}</li>
          <li><b>Rpm:</b> {{quantityRpm}}</li>
        </ul>
        <p-button *ngIf="!showGraficas" fluid="true" label="Generar Gráficas" (onClick)="mostrarGrafica()"></p-button>
      </div>
    </div>
    <div [style]="{'width': navigationService.isMobile() ? '100%' : '80%'}" style="text-align: center;">
      <h3>Recorrido</h3>
      <div #gmap class="resp-iframe map-active rounded" style="height: 80vh" *ngIf="showMap"></div>
    </div>
  </div>



  <div style="margin-top: 1em;" *ngIf="showGraficas">
    <div class="col-12" style="margin-top: 20px;" *ngIf="showSpeed">
      <app-grafica-velocidad-manez-lozano [grafica_vel]="grafica_vel" [grafica_pressure]="grafica_pressure"
        [grafica_rpm]="grafica_rpm" [grafica_flow]="grafica_flow" [grafica_dose]="grafica_dose" *ngIf="grafica_vel">
      </app-grafica-velocidad-manez-lozano>
    </div>
  </div>
</p-dialog>